import { NotificationModel } from '../models/Notifications.model';
import {
  NotificationDTO,
  NotificationRequestDTO,
} from '../dtos/Notifications.dto';
import {
  PushNotificationRequestDTO,
  SubmitPushNotificationRequestDTO,
} from '../../../../shared/components/push/dto/PushNotificationRequest.dto';

export class NotificationUtil {
  public static mapToViewModel(dto: NotificationDTO): NotificationModel {
    return {
      id: dto.id,
      body: dto.body,
      conversions: dto.conversions,
      data: dto.data,
      recipient: dto.recipient,
      schedule: dto.schedule,
      status: dto.status,
      title: dto.title,
      type: dto.type,
      withData: dto.withData,
      deliveredOn: dto.deliveredOn,
    };
  }

  public static toRequestDTO(
    model?: NotificationModel,
  ): NotificationRequestDTO {
    return {
      id: model ? model.id : undefined,
      title: model ? model.title : '',
      body: model ? model.body : '',
    };
  }

  public static pushNotificationToRequestDTO(
    pushNotification: PushNotificationRequestDTO,
  ): NotificationRequestDTO {
    return {
      id: pushNotification.id,
      title: pushNotification.title,
      body: pushNotification.body,
    };
  }

  public static toPushNotificationDTO(
    model?: NotificationModel,
  ): PushNotificationRequestDTO {
    return {
      id: model ? model.id : undefined,
      title: model ? model.title : '',
      body: model ? model.body : '',
      access: undefined,
      groups: undefined,
      recipients: undefined,
      open: false,
      scheduled: undefined,
      type: 'PUSH',
    };
  }

  public static toSubmitNotificaiontDTO(
    dto: PushNotificationRequestDTO,
  ): SubmitPushNotificationRequestDTO {
    return {
      id: dto.id,
      title: dto.title,
      body: dto.body,
      groups: dto.groups,
      recipients: dto.recipients,
      open: dto.open,
      scheduled: dto.scheduled,
    };
  }
}
